// source: proto/entity/opportunity.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var proto_common_crudFields_pb = require('../../proto/common/crudFields_pb.js');
goog.object.extend(proto, proto_common_crudFields_pb);
var proto_common_objectID_pb = require('../../proto/common/objectID_pb.js');
goog.object.extend(proto, proto_common_objectID_pb);
var proto_entity_action_pb = require('../../proto/entity/action_pb.js');
goog.object.extend(proto, proto_entity_action_pb);
var proto_entity_site_pb = require('../../proto/entity/site_pb.js');
goog.object.extend(proto, proto_entity_site_pb);
var proto_errorPb_error_pb = require('../../proto/errorPb/error_pb.js');
goog.object.extend(proto, proto_errorPb_error_pb);
goog.exportSymbol('proto.entity.NewOpportunity', null, global);
goog.exportSymbol('proto.entity.NewOpportunitySuspension', null, global);
goog.exportSymbol('proto.entity.Opportunity', null, global);
goog.exportSymbol('proto.entity.OpportunityDetails', null, global);
goog.exportSymbol('proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder', null, global);
goog.exportSymbol('proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables', null, global);
goog.exportSymbol('proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm', null, global);
goog.exportSymbol('proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables', null, global);
goog.exportSymbol('proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm', null, global);
goog.exportSymbol('proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables', null, global);
goog.exportSymbol('proto.entity.OpportunityDetails.IncreaseKeywordCPCBid', null, global);
goog.exportSymbol('proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables', null, global);
goog.exportSymbol('proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid', null, global);
goog.exportSymbol('proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables', null, global);
goog.exportSymbol('proto.entity.OpportunityDetails.NegateInefficientSearchTerm', null, global);
goog.exportSymbol('proto.entity.OpportunityDetails.TypeCase', null, global);
goog.exportSymbol('proto.entity.OpportunityExecutionFailure', null, global);
goog.exportSymbol('proto.entity.OpportunityStatus', null, global);
goog.exportSymbol('proto.entity.OpportunityStatus.Option', null, global);
goog.exportSymbol('proto.entity.OpportunitySuspension', null, global);
goog.exportSymbol('proto.entity.OpportunitySuspensionDetails', null, global);
goog.exportSymbol('proto.entity.SuspendedOpportunity', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.NewOpportunity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.NewOpportunity.repeatedFields_, null);
};
goog.inherits(proto.entity.NewOpportunity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.NewOpportunity.displayName = 'proto.entity.NewOpportunity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.Opportunity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.Opportunity.repeatedFields_, null);
};
goog.inherits(proto.entity.Opportunity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.Opportunity.displayName = 'proto.entity.Opportunity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.OpportunityDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.entity.OpportunityDetails.oneofGroups_);
};
goog.inherits(proto.entity.OpportunityDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.OpportunityDetails.displayName = 'proto.entity.OpportunityDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.repeatedFields_, null);
};
goog.inherits(proto.entity.OpportunityDetails.IncreaseKeywordCPCBid, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.displayName = 'proto.entity.OpportunityDetails.IncreaseKeywordCPCBid';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables.displayName = 'proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.repeatedFields_, null);
};
goog.inherits(proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.displayName = 'proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables.displayName = 'proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.repeatedFields_, null);
};
goog.inherits(proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.displayName = 'proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables.displayName = 'proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm.repeatedFields_, null);
};
goog.inherits(proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm.displayName = 'proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables.displayName = 'proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.repeatedFields_, null);
};
goog.inherits(proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.displayName = 'proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables.displayName = 'proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.OpportunityDetails.NegateInefficientSearchTerm, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.OpportunityDetails.NegateInefficientSearchTerm.displayName = 'proto.entity.OpportunityDetails.NegateInefficientSearchTerm';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.OpportunityStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.OpportunityStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.OpportunityStatus.displayName = 'proto.entity.OpportunityStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.OpportunityExecutionFailure = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.OpportunityExecutionFailure.repeatedFields_, null);
};
goog.inherits(proto.entity.OpportunityExecutionFailure, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.OpportunityExecutionFailure.displayName = 'proto.entity.OpportunityExecutionFailure';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.NewOpportunitySuspension = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.NewOpportunitySuspension, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.NewOpportunitySuspension.displayName = 'proto.entity.NewOpportunitySuspension';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.OpportunitySuspension = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.OpportunitySuspension, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.OpportunitySuspension.displayName = 'proto.entity.OpportunitySuspension';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.OpportunitySuspensionDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.OpportunitySuspensionDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.OpportunitySuspensionDetails.displayName = 'proto.entity.OpportunitySuspensionDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.SuspendedOpportunity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.SuspendedOpportunity.repeatedFields_, null);
};
goog.inherits(proto.entity.SuspendedOpportunity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.SuspendedOpportunity.displayName = 'proto.entity.SuspendedOpportunity';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.NewOpportunity.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.NewOpportunity.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.NewOpportunity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.NewOpportunity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.NewOpportunity.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    newActionsList: jspb.Message.toObjectList(msg.getNewActionsList(),
    proto_entity_action_pb.NewAction.toObject, includeInstance),
    details: (f = msg.getDetails()) && proto.entity.OpportunityDetails.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.NewOpportunity}
 */
proto.entity.NewOpportunity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.NewOpportunity;
  return proto.entity.NewOpportunity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.NewOpportunity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.NewOpportunity}
 */
proto.entity.NewOpportunity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = new proto_entity_action_pb.NewAction;
      reader.readMessage(value,proto_entity_action_pb.NewAction.deserializeBinaryFromReader);
      msg.addNewActions(value);
      break;
    case 3:
      var value = new proto.entity.OpportunityDetails;
      reader.readMessage(value,proto.entity.OpportunityDetails.deserializeBinaryFromReader);
      msg.setDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.NewOpportunity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.NewOpportunity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.NewOpportunity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.NewOpportunity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getNewActionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto_entity_action_pb.NewAction.serializeBinaryToWriter
    );
  }
  f = message.getDetails();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.entity.OpportunityDetails.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.NewOpportunity.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.NewOpportunity} returns this
*/
proto.entity.NewOpportunity.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.NewOpportunity} returns this
 */
proto.entity.NewOpportunity.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.NewOpportunity.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated NewAction new_actions = 2;
 * @return {!Array<!proto.entity.NewAction>}
 */
proto.entity.NewOpportunity.prototype.getNewActionsList = function() {
  return /** @type{!Array<!proto.entity.NewAction>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_action_pb.NewAction, 2));
};


/**
 * @param {!Array<!proto.entity.NewAction>} value
 * @return {!proto.entity.NewOpportunity} returns this
*/
proto.entity.NewOpportunity.prototype.setNewActionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.entity.NewAction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.NewAction}
 */
proto.entity.NewOpportunity.prototype.addNewActions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.entity.NewAction, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.NewOpportunity} returns this
 */
proto.entity.NewOpportunity.prototype.clearNewActionsList = function() {
  return this.setNewActionsList([]);
};


/**
 * optional OpportunityDetails details = 3;
 * @return {?proto.entity.OpportunityDetails}
 */
proto.entity.NewOpportunity.prototype.getDetails = function() {
  return /** @type{?proto.entity.OpportunityDetails} */ (
    jspb.Message.getWrapperField(this, proto.entity.OpportunityDetails, 3));
};


/**
 * @param {?proto.entity.OpportunityDetails|undefined} value
 * @return {!proto.entity.NewOpportunity} returns this
*/
proto.entity.NewOpportunity.prototype.setDetails = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.NewOpportunity} returns this
 */
proto.entity.NewOpportunity.prototype.clearDetails = function() {
  return this.setDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.NewOpportunity.prototype.hasDetails = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.Opportunity.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.Opportunity.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.Opportunity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.Opportunity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.Opportunity.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: (f = msg.getSiteId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f),
    opportunityId: (f = msg.getOpportunityId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 6, 0),
    actionsList: jspb.Message.toObjectList(msg.getActionsList(),
    proto_entity_action_pb.Action.toObject, includeInstance),
    details: (f = msg.getDetails()) && proto.entity.OpportunityDetails.toObject(includeInstance, f),
    crudFields: (f = msg.getCrudFields()) && proto_common_crudFields_pb.CRUDFields.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.Opportunity}
 */
proto.entity.Opportunity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.Opportunity;
  return proto.entity.Opportunity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.Opportunity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.Opportunity}
 */
proto.entity.Opportunity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setSiteId(value);
      break;
    case 2:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setOpportunityId(value);
      break;
    case 6:
      var value = /** @type {!proto.entity.OpportunityStatus.Option} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 3:
      var value = new proto_entity_action_pb.Action;
      reader.readMessage(value,proto_entity_action_pb.Action.deserializeBinaryFromReader);
      msg.addActions(value);
      break;
    case 4:
      var value = new proto.entity.OpportunityDetails;
      reader.readMessage(value,proto.entity.OpportunityDetails.deserializeBinaryFromReader);
      msg.setDetails(value);
      break;
    case 5:
      var value = new proto_common_crudFields_pb.CRUDFields;
      reader.readMessage(value,proto_common_crudFields_pb.CRUDFields.deserializeBinaryFromReader);
      msg.setCrudFields(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.Opportunity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.Opportunity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.Opportunity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.Opportunity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getOpportunityId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getActionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto_entity_action_pb.Action.serializeBinaryToWriter
    );
  }
  f = message.getDetails();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.entity.OpportunityDetails.serializeBinaryToWriter
    );
  }
  f = message.getCrudFields();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto_common_crudFields_pb.CRUDFields.serializeBinaryToWriter
    );
  }
};


/**
 * optional common.ObjectID site_id = 1;
 * @return {?proto.common.ObjectID}
 */
proto.entity.Opportunity.prototype.getSiteId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 1));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.Opportunity} returns this
*/
proto.entity.Opportunity.prototype.setSiteId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.Opportunity} returns this
 */
proto.entity.Opportunity.prototype.clearSiteId = function() {
  return this.setSiteId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.Opportunity.prototype.hasSiteId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.ObjectID opportunity_id = 2;
 * @return {?proto.common.ObjectID}
 */
proto.entity.Opportunity.prototype.getOpportunityId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 2));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.Opportunity} returns this
*/
proto.entity.Opportunity.prototype.setOpportunityId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.Opportunity} returns this
 */
proto.entity.Opportunity.prototype.clearOpportunityId = function() {
  return this.setOpportunityId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.Opportunity.prototype.hasOpportunityId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional OpportunityStatus.Option status = 6;
 * @return {!proto.entity.OpportunityStatus.Option}
 */
proto.entity.Opportunity.prototype.getStatus = function() {
  return /** @type {!proto.entity.OpportunityStatus.Option} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.entity.OpportunityStatus.Option} value
 * @return {!proto.entity.Opportunity} returns this
 */
proto.entity.Opportunity.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * repeated Action actions = 3;
 * @return {!Array<!proto.entity.Action>}
 */
proto.entity.Opportunity.prototype.getActionsList = function() {
  return /** @type{!Array<!proto.entity.Action>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_action_pb.Action, 3));
};


/**
 * @param {!Array<!proto.entity.Action>} value
 * @return {!proto.entity.Opportunity} returns this
*/
proto.entity.Opportunity.prototype.setActionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.entity.Action=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.Action}
 */
proto.entity.Opportunity.prototype.addActions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.entity.Action, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.Opportunity} returns this
 */
proto.entity.Opportunity.prototype.clearActionsList = function() {
  return this.setActionsList([]);
};


/**
 * optional OpportunityDetails details = 4;
 * @return {?proto.entity.OpportunityDetails}
 */
proto.entity.Opportunity.prototype.getDetails = function() {
  return /** @type{?proto.entity.OpportunityDetails} */ (
    jspb.Message.getWrapperField(this, proto.entity.OpportunityDetails, 4));
};


/**
 * @param {?proto.entity.OpportunityDetails|undefined} value
 * @return {!proto.entity.Opportunity} returns this
*/
proto.entity.Opportunity.prototype.setDetails = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.Opportunity} returns this
 */
proto.entity.Opportunity.prototype.clearDetails = function() {
  return this.setDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.Opportunity.prototype.hasDetails = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional common.CRUDFields crud_fields = 5;
 * @return {?proto.common.CRUDFields}
 */
proto.entity.Opportunity.prototype.getCrudFields = function() {
  return /** @type{?proto.common.CRUDFields} */ (
    jspb.Message.getWrapperField(this, proto_common_crudFields_pb.CRUDFields, 5));
};


/**
 * @param {?proto.common.CRUDFields|undefined} value
 * @return {!proto.entity.Opportunity} returns this
*/
proto.entity.Opportunity.prototype.setCrudFields = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.Opportunity} returns this
 */
proto.entity.Opportunity.prototype.clearCrudFields = function() {
  return this.setCrudFields(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.Opportunity.prototype.hasCrudFields = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.entity.OpportunityDetails.oneofGroups_ = [[1,2,3,5,6,7]];

/**
 * @enum {number}
 */
proto.entity.OpportunityDetails.TypeCase = {
  TYPE_NOT_SET: 0,
  INCREASE_KEYWORD_CPC_BID: 1,
  INCREASE_PRODUCT_GROUP_CPC_BID: 2,
  ADD_KEYWORD_FROM_SHOPPING_SEARCH_TERM: 3,
  ADD_KEYWORD_FROM_ORGANIC_SEARCH_TERM: 5,
  ADD_DYNAMIC_SEARCH_FOR_SITEMAP_FOLDER: 6,
  NEGATE_INEFFICIENT_SEARCH_TERM: 7
};

/**
 * @return {proto.entity.OpportunityDetails.TypeCase}
 */
proto.entity.OpportunityDetails.prototype.getTypeCase = function() {
  return /** @type {proto.entity.OpportunityDetails.TypeCase} */(jspb.Message.computeOneofCase(this, proto.entity.OpportunityDetails.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.OpportunityDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.OpportunityDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.OpportunityDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    increaseKeywordCpcBid: (f = msg.getIncreaseKeywordCpcBid()) && proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.toObject(includeInstance, f),
    increaseProductGroupCpcBid: (f = msg.getIncreaseProductGroupCpcBid()) && proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.toObject(includeInstance, f),
    addKeywordFromShoppingSearchTerm: (f = msg.getAddKeywordFromShoppingSearchTerm()) && proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.toObject(includeInstance, f),
    addKeywordFromOrganicSearchTerm: (f = msg.getAddKeywordFromOrganicSearchTerm()) && proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm.toObject(includeInstance, f),
    addDynamicSearchForSitemapFolder: (f = msg.getAddDynamicSearchForSitemapFolder()) && proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.toObject(includeInstance, f),
    negateInefficientSearchTerm: (f = msg.getNegateInefficientSearchTerm()) && proto.entity.OpportunityDetails.NegateInefficientSearchTerm.toObject(includeInstance, f),
    priorityWithinType: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.OpportunityDetails}
 */
proto.entity.OpportunityDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.OpportunityDetails;
  return proto.entity.OpportunityDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.OpportunityDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.OpportunityDetails}
 */
proto.entity.OpportunityDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.entity.OpportunityDetails.IncreaseKeywordCPCBid;
      reader.readMessage(value,proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.deserializeBinaryFromReader);
      msg.setIncreaseKeywordCpcBid(value);
      break;
    case 2:
      var value = new proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid;
      reader.readMessage(value,proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.deserializeBinaryFromReader);
      msg.setIncreaseProductGroupCpcBid(value);
      break;
    case 3:
      var value = new proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm;
      reader.readMessage(value,proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.deserializeBinaryFromReader);
      msg.setAddKeywordFromShoppingSearchTerm(value);
      break;
    case 5:
      var value = new proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm;
      reader.readMessage(value,proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm.deserializeBinaryFromReader);
      msg.setAddKeywordFromOrganicSearchTerm(value);
      break;
    case 6:
      var value = new proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder;
      reader.readMessage(value,proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.deserializeBinaryFromReader);
      msg.setAddDynamicSearchForSitemapFolder(value);
      break;
    case 7:
      var value = new proto.entity.OpportunityDetails.NegateInefficientSearchTerm;
      reader.readMessage(value,proto.entity.OpportunityDetails.NegateInefficientSearchTerm.deserializeBinaryFromReader);
      msg.setNegateInefficientSearchTerm(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPriorityWithinType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.OpportunityDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.OpportunityDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.OpportunityDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIncreaseKeywordCpcBid();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.serializeBinaryToWriter
    );
  }
  f = message.getIncreaseProductGroupCpcBid();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.serializeBinaryToWriter
    );
  }
  f = message.getAddKeywordFromShoppingSearchTerm();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.serializeBinaryToWriter
    );
  }
  f = message.getAddKeywordFromOrganicSearchTerm();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm.serializeBinaryToWriter
    );
  }
  f = message.getAddDynamicSearchForSitemapFolder();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.serializeBinaryToWriter
    );
  }
  f = message.getNegateInefficientSearchTerm();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.entity.OpportunityDetails.NegateInefficientSearchTerm.serializeBinaryToWriter
    );
  }
  f = message.getPriorityWithinType();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.repeatedFields_ = [101];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBid} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.toObject = function(includeInstance, msg) {
  var f, obj = {
    campaignName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    adGroupName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    keywordText: jspb.Message.getFieldWithDefault(msg, 3, ""),
    averageCpc: jspb.Message.getFieldWithDefault(msg, 4, ""),
    currentCpcBid: jspb.Message.getFieldWithDefault(msg, 5, ""),
    topImpressionShare: jspb.Message.getFieldWithDefault(msg, 6, ""),
    roas: jspb.Message.getFieldWithDefault(msg, 7, ""),
    conversionValue: jspb.Message.getFieldWithDefault(msg, 8, ""),
    cost: jspb.Message.getFieldWithDefault(msg, 9, ""),
    conversions: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
    clicks: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
    impressions: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0),
    startDate: jspb.Message.getFieldWithDefault(msg, 13, ""),
    endDate: jspb.Message.getFieldWithDefault(msg, 14, ""),
    active: (f = msg.getActive()) && proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables.toObject(includeInstance, f),
    alternativesList: jspb.Message.toObjectList(msg.getAlternativesList(),
    proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBid}
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.OpportunityDetails.IncreaseKeywordCPCBid;
  return proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBid} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBid}
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCampaignName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdGroupName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setKeywordText(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAverageCpc(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentCpcBid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTopImpressionShare(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoas(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setConversionValue(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCost(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setConversions(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setClicks(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setImpressions(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartDate(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndDate(value);
      break;
    case 100:
      var value = new proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables;
      reader.readMessage(value,proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables.deserializeBinaryFromReader);
      msg.setActive(value);
      break;
    case 101:
      var value = new proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables;
      reader.readMessage(value,proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables.deserializeBinaryFromReader);
      msg.addAlternatives(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBid} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCampaignName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAdGroupName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getKeywordText();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAverageCpc();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCurrentCpcBid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTopImpressionShare();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getRoas();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getConversionValue();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCost();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getConversions();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getClicks();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = message.getImpressions();
  if (f !== 0.0) {
    writer.writeDouble(
      12,
      f
    );
  }
  f = message.getStartDate();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getEndDate();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getActive();
  if (f != null) {
    writer.writeMessage(
      100,
      f,
      proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables.serializeBinaryToWriter
    );
  }
  f = message.getAlternativesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      101,
      f,
      proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables.serializeBinaryToWriter
    );
  }
};


/**
 * optional string campaign_name = 1;
 * @return {string}
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.getCampaignName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.setCampaignName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ad_group_name = 2;
 * @return {string}
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.getAdGroupName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.setAdGroupName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string keyword_text = 3;
 * @return {string}
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.getKeywordText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.setKeywordText = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string average_cpc = 4;
 * @return {string}
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.getAverageCpc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.setAverageCpc = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string current_cpc_bid = 5;
 * @return {string}
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.getCurrentCpcBid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.setCurrentCpcBid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string top_impression_share = 6;
 * @return {string}
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.getTopImpressionShare = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.setTopImpressionShare = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string roas = 7;
 * @return {string}
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.getRoas = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.setRoas = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string conversion_value = 8;
 * @return {string}
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.getConversionValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.setConversionValue = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string cost = 9;
 * @return {string}
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.getCost = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.setCost = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional double conversions = 10;
 * @return {number}
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.getConversions = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.setConversions = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional double clicks = 11;
 * @return {number}
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.getClicks = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.setClicks = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional double impressions = 12;
 * @return {number}
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.getImpressions = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.setImpressions = function(value) {
  return jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional string start_date = 13;
 * @return {string}
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.getStartDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.setStartDate = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string end_date = 14;
 * @return {string}
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.getEndDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.setEndDate = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional IncreaseKeywordCPCBidVariables active = 100;
 * @return {?proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables}
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.getActive = function() {
  return /** @type{?proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables} */ (
    jspb.Message.getWrapperField(this, proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables, 100));
};


/**
 * @param {?proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables|undefined} value
 * @return {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBid} returns this
*/
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.setActive = function(value) {
  return jspb.Message.setWrapperField(this, 100, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.clearActive = function() {
  return this.setActive(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.hasActive = function() {
  return jspb.Message.getField(this, 100) != null;
};


/**
 * repeated IncreaseKeywordCPCBidVariables alternatives = 101;
 * @return {!Array<!proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables>}
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.getAlternativesList = function() {
  return /** @type{!Array<!proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables, 101));
};


/**
 * @param {!Array<!proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables>} value
 * @return {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBid} returns this
*/
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.setAlternativesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 101, value);
};


/**
 * @param {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables}
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.addAlternatives = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 101, opt_value, proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBid.prototype.clearAlternativesList = function() {
  return this.setAlternativesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables.toObject = function(includeInstance, msg) {
  var f, obj = {
    newCpcBid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    cpcBidReason: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables}
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables;
  return proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables}
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewCpcBid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCpcBidReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewCpcBid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCpcBidReason();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string new_cpc_bid = 1;
 * @return {string}
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables.prototype.getNewCpcBid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables} returns this
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables.prototype.setNewCpcBid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string cpc_bid_reason = 2;
 * @return {string}
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables.prototype.getCpcBidReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables} returns this
 */
proto.entity.OpportunityDetails.IncreaseKeywordCPCBidVariables.prototype.setCpcBidReason = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.repeatedFields_ = [101];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.toObject = function(includeInstance, msg) {
  var f, obj = {
    campaignName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    adGroupName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    productGroup: jspb.Message.getFieldWithDefault(msg, 3, ""),
    averageCpc: jspb.Message.getFieldWithDefault(msg, 4, ""),
    currentCpcBid: jspb.Message.getFieldWithDefault(msg, 5, ""),
    impressionShare: jspb.Message.getFieldWithDefault(msg, 6, ""),
    roas: jspb.Message.getFieldWithDefault(msg, 7, ""),
    conversionValue: jspb.Message.getFieldWithDefault(msg, 8, ""),
    cost: jspb.Message.getFieldWithDefault(msg, 9, ""),
    conversions: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
    clicks: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
    impressions: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0),
    startDate: jspb.Message.getFieldWithDefault(msg, 13, ""),
    endDate: jspb.Message.getFieldWithDefault(msg, 14, ""),
    active: (f = msg.getActive()) && proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables.toObject(includeInstance, f),
    alternativesList: jspb.Message.toObjectList(msg.getAlternativesList(),
    proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid}
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid;
  return proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid}
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCampaignName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdGroupName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductGroup(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAverageCpc(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentCpcBid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setImpressionShare(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoas(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setConversionValue(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCost(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setConversions(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setClicks(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setImpressions(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartDate(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndDate(value);
      break;
    case 100:
      var value = new proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables;
      reader.readMessage(value,proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables.deserializeBinaryFromReader);
      msg.setActive(value);
      break;
    case 101:
      var value = new proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables;
      reader.readMessage(value,proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables.deserializeBinaryFromReader);
      msg.addAlternatives(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCampaignName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAdGroupName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProductGroup();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAverageCpc();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCurrentCpcBid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getImpressionShare();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getRoas();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getConversionValue();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCost();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getConversions();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getClicks();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = message.getImpressions();
  if (f !== 0.0) {
    writer.writeDouble(
      12,
      f
    );
  }
  f = message.getStartDate();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getEndDate();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getActive();
  if (f != null) {
    writer.writeMessage(
      100,
      f,
      proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables.serializeBinaryToWriter
    );
  }
  f = message.getAlternativesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      101,
      f,
      proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables.serializeBinaryToWriter
    );
  }
};


/**
 * optional string campaign_name = 1;
 * @return {string}
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.getCampaignName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.setCampaignName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ad_group_name = 2;
 * @return {string}
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.getAdGroupName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.setAdGroupName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string product_group = 3;
 * @return {string}
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.getProductGroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.setProductGroup = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string average_cpc = 4;
 * @return {string}
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.getAverageCpc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.setAverageCpc = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string current_cpc_bid = 5;
 * @return {string}
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.getCurrentCpcBid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.setCurrentCpcBid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string impression_share = 6;
 * @return {string}
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.getImpressionShare = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.setImpressionShare = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string roas = 7;
 * @return {string}
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.getRoas = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.setRoas = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string conversion_value = 8;
 * @return {string}
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.getConversionValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.setConversionValue = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string cost = 9;
 * @return {string}
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.getCost = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.setCost = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional double conversions = 10;
 * @return {number}
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.getConversions = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.setConversions = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional double clicks = 11;
 * @return {number}
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.getClicks = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.setClicks = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional double impressions = 12;
 * @return {number}
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.getImpressions = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.setImpressions = function(value) {
  return jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional string start_date = 13;
 * @return {string}
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.getStartDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.setStartDate = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string end_date = 14;
 * @return {string}
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.getEndDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.setEndDate = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional IncreaseProductGroupCPCBidVariables active = 100;
 * @return {?proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables}
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.getActive = function() {
  return /** @type{?proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables} */ (
    jspb.Message.getWrapperField(this, proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables, 100));
};


/**
 * @param {?proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables|undefined} value
 * @return {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid} returns this
*/
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.setActive = function(value) {
  return jspb.Message.setWrapperField(this, 100, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.clearActive = function() {
  return this.setActive(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.hasActive = function() {
  return jspb.Message.getField(this, 100) != null;
};


/**
 * repeated IncreaseProductGroupCPCBidVariables alternatives = 101;
 * @return {!Array<!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables>}
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.getAlternativesList = function() {
  return /** @type{!Array<!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables, 101));
};


/**
 * @param {!Array<!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables>} value
 * @return {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid} returns this
*/
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.setAlternativesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 101, value);
};


/**
 * @param {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables}
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.addAlternatives = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 101, opt_value, proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid} returns this
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid.prototype.clearAlternativesList = function() {
  return this.setAlternativesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables.toObject = function(includeInstance, msg) {
  var f, obj = {
    newCpcBid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    cpcBidReason: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables}
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables;
  return proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables}
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewCpcBid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCpcBidReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewCpcBid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCpcBidReason();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string new_cpc_bid = 1;
 * @return {string}
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables.prototype.getNewCpcBid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables} returns this
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables.prototype.setNewCpcBid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string cpc_bid_reason = 2;
 * @return {string}
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables.prototype.getCpcBidReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables} returns this
 */
proto.entity.OpportunityDetails.IncreaseProductGroupCPCBidVariables.prototype.setCpcBidReason = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.repeatedFields_ = [101];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.toObject = function(includeInstance, msg) {
  var f, obj = {
    averageCpc: jspb.Message.getFieldWithDefault(msg, 1, ""),
    roas: jspb.Message.getFieldWithDefault(msg, 2, ""),
    conversionValue: jspb.Message.getFieldWithDefault(msg, 3, ""),
    cost: jspb.Message.getFieldWithDefault(msg, 4, ""),
    conversions: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    clicks: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    impressions: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    startDate: jspb.Message.getFieldWithDefault(msg, 8, ""),
    endDate: jspb.Message.getFieldWithDefault(msg, 9, ""),
    active: (f = msg.getActive()) && proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables.toObject(includeInstance, f),
    alternativesList: jspb.Message.toObjectList(msg.getAlternativesList(),
    proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm}
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm;
  return proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm}
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAverageCpc(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoas(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setConversionValue(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCost(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setConversions(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setClicks(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setImpressions(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartDate(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndDate(value);
      break;
    case 100:
      var value = new proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables;
      reader.readMessage(value,proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables.deserializeBinaryFromReader);
      msg.setActive(value);
      break;
    case 101:
      var value = new proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables;
      reader.readMessage(value,proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables.deserializeBinaryFromReader);
      msg.addAlternatives(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAverageCpc();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRoas();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getConversionValue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCost();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getConversions();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getClicks();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getImpressions();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getStartDate();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getEndDate();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getActive();
  if (f != null) {
    writer.writeMessage(
      100,
      f,
      proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables.serializeBinaryToWriter
    );
  }
  f = message.getAlternativesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      101,
      f,
      proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables.serializeBinaryToWriter
    );
  }
};


/**
 * optional string average_cpc = 1;
 * @return {string}
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.prototype.getAverageCpc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm} returns this
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.prototype.setAverageCpc = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string roas = 2;
 * @return {string}
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.prototype.getRoas = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm} returns this
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.prototype.setRoas = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string conversion_value = 3;
 * @return {string}
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.prototype.getConversionValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm} returns this
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.prototype.setConversionValue = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string cost = 4;
 * @return {string}
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.prototype.getCost = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm} returns this
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.prototype.setCost = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double conversions = 5;
 * @return {number}
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.prototype.getConversions = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm} returns this
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.prototype.setConversions = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double clicks = 6;
 * @return {number}
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.prototype.getClicks = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm} returns this
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.prototype.setClicks = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double impressions = 7;
 * @return {number}
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.prototype.getImpressions = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm} returns this
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.prototype.setImpressions = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional string start_date = 8;
 * @return {string}
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.prototype.getStartDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm} returns this
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.prototype.setStartDate = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string end_date = 9;
 * @return {string}
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.prototype.getEndDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm} returns this
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.prototype.setEndDate = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional AddKeywordFromShoppingSearchTermVariables active = 100;
 * @return {?proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables}
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.prototype.getActive = function() {
  return /** @type{?proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables} */ (
    jspb.Message.getWrapperField(this, proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables, 100));
};


/**
 * @param {?proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables|undefined} value
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm} returns this
*/
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.prototype.setActive = function(value) {
  return jspb.Message.setWrapperField(this, 100, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm} returns this
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.prototype.clearActive = function() {
  return this.setActive(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.prototype.hasActive = function() {
  return jspb.Message.getField(this, 100) != null;
};


/**
 * repeated AddKeywordFromShoppingSearchTermVariables alternatives = 101;
 * @return {!Array<!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables>}
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.prototype.getAlternativesList = function() {
  return /** @type{!Array<!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables, 101));
};


/**
 * @param {!Array<!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables>} value
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm} returns this
*/
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.prototype.setAlternativesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 101, value);
};


/**
 * @param {!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables}
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.prototype.addAlternatives = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 101, opt_value, proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm} returns this
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm.prototype.clearAlternativesList = function() {
  return this.setAlternativesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables.toObject = function(includeInstance, msg) {
  var f, obj = {
    newKeywordText: jspb.Message.getFieldWithDefault(msg, 1, ""),
    newCampaignName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    newAdGroupName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    defaultCpcBid: jspb.Message.getFieldWithDefault(msg, 6, ""),
    newCpcBid: jspb.Message.getFieldWithDefault(msg, 7, ""),
    cpcBidReason: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables}
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables;
  return proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables}
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewKeywordText(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewCampaignName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewAdGroupName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDefaultCpcBid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewCpcBid(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCpcBidReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewKeywordText();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNewCampaignName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getNewAdGroupName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDefaultCpcBid();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getNewCpcBid();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCpcBidReason();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string new_keyword_text = 1;
 * @return {string}
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables.prototype.getNewKeywordText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables} returns this
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables.prototype.setNewKeywordText = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string new_campaign_name = 3;
 * @return {string}
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables.prototype.getNewCampaignName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables} returns this
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables.prototype.setNewCampaignName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string new_ad_group_name = 5;
 * @return {string}
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables.prototype.getNewAdGroupName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables} returns this
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables.prototype.setNewAdGroupName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string default_cpc_bid = 6;
 * @return {string}
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables.prototype.getDefaultCpcBid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables} returns this
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables.prototype.setDefaultCpcBid = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string new_cpc_bid = 7;
 * @return {string}
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables.prototype.getNewCpcBid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables} returns this
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables.prototype.setNewCpcBid = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string cpc_bid_reason = 8;
 * @return {string}
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables.prototype.getCpcBidReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables} returns this
 */
proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTermVariables.prototype.setCpcBidReason = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm.repeatedFields_ = [101];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm.toObject = function(includeInstance, msg) {
  var f, obj = {
    avgCpc: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    searchVolume: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    competition: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    active: (f = msg.getActive()) && proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables.toObject(includeInstance, f),
    alternativesList: jspb.Message.toObjectList(msg.getAlternativesList(),
    proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm}
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm;
  return proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm}
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAvgCpc(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSearchVolume(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCompetition(value);
      break;
    case 100:
      var value = new proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables;
      reader.readMessage(value,proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables.deserializeBinaryFromReader);
      msg.setActive(value);
      break;
    case 101:
      var value = new proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables;
      reader.readMessage(value,proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables.deserializeBinaryFromReader);
      msg.addAlternatives(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAvgCpc();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getSearchVolume();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getCompetition();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getActive();
  if (f != null) {
    writer.writeMessage(
      100,
      f,
      proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables.serializeBinaryToWriter
    );
  }
  f = message.getAlternativesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      101,
      f,
      proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables.serializeBinaryToWriter
    );
  }
};


/**
 * optional double avg_cpc = 1;
 * @return {number}
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm.prototype.getAvgCpc = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm} returns this
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm.prototype.setAvgCpc = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double search_volume = 2;
 * @return {number}
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm.prototype.getSearchVolume = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm} returns this
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm.prototype.setSearchVolume = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double competition = 3;
 * @return {number}
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm.prototype.getCompetition = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm} returns this
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm.prototype.setCompetition = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional AddKeywordFromOrganicSearchTermVariables active = 100;
 * @return {?proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables}
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm.prototype.getActive = function() {
  return /** @type{?proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables} */ (
    jspb.Message.getWrapperField(this, proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables, 100));
};


/**
 * @param {?proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables|undefined} value
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm} returns this
*/
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm.prototype.setActive = function(value) {
  return jspb.Message.setWrapperField(this, 100, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm} returns this
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm.prototype.clearActive = function() {
  return this.setActive(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm.prototype.hasActive = function() {
  return jspb.Message.getField(this, 100) != null;
};


/**
 * repeated AddKeywordFromOrganicSearchTermVariables alternatives = 101;
 * @return {!Array<!proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables>}
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm.prototype.getAlternativesList = function() {
  return /** @type{!Array<!proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables, 101));
};


/**
 * @param {!Array<!proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables>} value
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm} returns this
*/
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm.prototype.setAlternativesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 101, value);
};


/**
 * @param {!proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables}
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm.prototype.addAlternatives = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 101, opt_value, proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm} returns this
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm.prototype.clearAlternativesList = function() {
  return this.setAlternativesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables.toObject = function(includeInstance, msg) {
  var f, obj = {
    newKeywordText: jspb.Message.getFieldWithDefault(msg, 1, ""),
    newCampaignName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    newAdGroupName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    defaultCpcBid: jspb.Message.getFieldWithDefault(msg, 6, ""),
    newCpcBid: jspb.Message.getFieldWithDefault(msg, 7, ""),
    cpcBidReason: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables}
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables;
  return proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables}
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewKeywordText(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewCampaignName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewAdGroupName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDefaultCpcBid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewCpcBid(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCpcBidReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewKeywordText();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNewCampaignName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getNewAdGroupName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDefaultCpcBid();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getNewCpcBid();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCpcBidReason();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string new_keyword_text = 1;
 * @return {string}
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables.prototype.getNewKeywordText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables} returns this
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables.prototype.setNewKeywordText = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string new_campaign_name = 3;
 * @return {string}
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables.prototype.getNewCampaignName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables} returns this
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables.prototype.setNewCampaignName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string new_ad_group_name = 5;
 * @return {string}
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables.prototype.getNewAdGroupName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables} returns this
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables.prototype.setNewAdGroupName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string default_cpc_bid = 6;
 * @return {string}
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables.prototype.getDefaultCpcBid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables} returns this
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables.prototype.setDefaultCpcBid = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string new_cpc_bid = 7;
 * @return {string}
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables.prototype.getNewCpcBid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables} returns this
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables.prototype.setNewCpcBid = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string cpc_bid_reason = 8;
 * @return {string}
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables.prototype.getCpcBidReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables} returns this
 */
proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTermVariables.prototype.setCpcBidReason = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.repeatedFields_ = [101];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.toObject = function(includeInstance, msg) {
  var f, obj = {
    sitemapFolderUrl: jspb.Message.getFieldWithDefault(msg, 1, ""),
    folderPageCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    untargetedPageCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
    dynamicSearchTargetedPageCount: jspb.Message.getFieldWithDefault(msg, 4, 0),
    standardSearchTargetedPageCount: jspb.Message.getFieldWithDefault(msg, 5, 0),
    otherTargetedPageCount: jspb.Message.getFieldWithDefault(msg, 6, 0),
    active: (f = msg.getActive()) && proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables.toObject(includeInstance, f),
    alternativesList: jspb.Message.toObjectList(msg.getAlternativesList(),
    proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder}
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder;
  return proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder}
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSitemapFolderUrl(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFolderPageCount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUntargetedPageCount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDynamicSearchTargetedPageCount(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStandardSearchTargetedPageCount(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOtherTargetedPageCount(value);
      break;
    case 100:
      var value = new proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables;
      reader.readMessage(value,proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables.deserializeBinaryFromReader);
      msg.setActive(value);
      break;
    case 101:
      var value = new proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables;
      reader.readMessage(value,proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables.deserializeBinaryFromReader);
      msg.addAlternatives(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSitemapFolderUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFolderPageCount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getUntargetedPageCount();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getDynamicSearchTargetedPageCount();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getStandardSearchTargetedPageCount();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getOtherTargetedPageCount();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getActive();
  if (f != null) {
    writer.writeMessage(
      100,
      f,
      proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables.serializeBinaryToWriter
    );
  }
  f = message.getAlternativesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      101,
      f,
      proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables.serializeBinaryToWriter
    );
  }
};


/**
 * optional string sitemap_folder_url = 1;
 * @return {string}
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.prototype.getSitemapFolderUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder} returns this
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.prototype.setSitemapFolderUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 folder_page_count = 2;
 * @return {number}
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.prototype.getFolderPageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder} returns this
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.prototype.setFolderPageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 untargeted_page_count = 3;
 * @return {number}
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.prototype.getUntargetedPageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder} returns this
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.prototype.setUntargetedPageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 dynamic_search_targeted_page_count = 4;
 * @return {number}
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.prototype.getDynamicSearchTargetedPageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder} returns this
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.prototype.setDynamicSearchTargetedPageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 standard_search_targeted_page_count = 5;
 * @return {number}
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.prototype.getStandardSearchTargetedPageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder} returns this
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.prototype.setStandardSearchTargetedPageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 other_targeted_page_count = 6;
 * @return {number}
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.prototype.getOtherTargetedPageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder} returns this
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.prototype.setOtherTargetedPageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional AddDynamicSearchForSitemapFolderVariables active = 100;
 * @return {?proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables}
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.prototype.getActive = function() {
  return /** @type{?proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables} */ (
    jspb.Message.getWrapperField(this, proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables, 100));
};


/**
 * @param {?proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables|undefined} value
 * @return {!proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder} returns this
*/
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.prototype.setActive = function(value) {
  return jspb.Message.setWrapperField(this, 100, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder} returns this
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.prototype.clearActive = function() {
  return this.setActive(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.prototype.hasActive = function() {
  return jspb.Message.getField(this, 100) != null;
};


/**
 * repeated AddDynamicSearchForSitemapFolderVariables alternatives = 101;
 * @return {!Array<!proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables>}
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.prototype.getAlternativesList = function() {
  return /** @type{!Array<!proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables, 101));
};


/**
 * @param {!Array<!proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables>} value
 * @return {!proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder} returns this
*/
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.prototype.setAlternativesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 101, value);
};


/**
 * @param {!proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables}
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.prototype.addAlternatives = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 101, opt_value, proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder} returns this
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder.prototype.clearAlternativesList = function() {
  return this.setAlternativesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables.toObject = function(includeInstance, msg) {
  var f, obj = {
    campaignBudget: jspb.Message.getFieldWithDefault(msg, 1, ""),
    biddingStrategyDesc: jspb.Message.getFieldWithDefault(msg, 2, ""),
    languageName: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables}
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables;
  return proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables}
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCampaignBudget(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBiddingStrategyDesc(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguageName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCampaignBudget();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBiddingStrategyDesc();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLanguageName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string campaign_budget = 1;
 * @return {string}
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables.prototype.getCampaignBudget = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables} returns this
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables.prototype.setCampaignBudget = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string bidding_strategy_desc = 2;
 * @return {string}
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables.prototype.getBiddingStrategyDesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables} returns this
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables.prototype.setBiddingStrategyDesc = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string language_name = 3;
 * @return {string}
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables.prototype.getLanguageName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables} returns this
 */
proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolderVariables.prototype.setLanguageName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.OpportunityDetails.NegateInefficientSearchTerm.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.OpportunityDetails.NegateInefficientSearchTerm} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.toObject = function(includeInstance, msg) {
  var f, obj = {
    campaignId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    campaignName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    adGroupName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    searchTerm: jspb.Message.getFieldWithDefault(msg, 20, ""),
    estimatedAov: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
    expectedRoas: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    expectedConversionRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    revenueDiffScore: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    roasUnderperformingProb: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    targetRoas: jspb.Message.getFloatingPointFieldWithDefault(msg, 23, 0.0),
    clicks: jspb.Message.getFieldWithDefault(msg, 9, 0),
    conversions: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
    cost: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
    costPerClick: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0),
    revenue: jspb.Message.getFloatingPointFieldWithDefault(msg, 13, 0.0),
    roas: jspb.Message.getFloatingPointFieldWithDefault(msg, 14, 0.0),
    topImpressionPercentage: jspb.Message.getFloatingPointFieldWithDefault(msg, 22, 0.0),
    campaignEstimatedAov: jspb.Message.getFloatingPointFieldWithDefault(msg, 17, 0.0),
    campaignExpectedRoas: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
    campaignExpectedConversionRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 16, 0.0),
    campaignClicks: jspb.Message.getFieldWithDefault(msg, 18, 0),
    campaignCost: jspb.Message.getFloatingPointFieldWithDefault(msg, 19, 0.0),
    campaignCostPerClick: jspb.Message.getFloatingPointFieldWithDefault(msg, 21, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.OpportunityDetails.NegateInefficientSearchTerm}
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.OpportunityDetails.NegateInefficientSearchTerm;
  return proto.entity.OpportunityDetails.NegateInefficientSearchTerm.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.OpportunityDetails.NegateInefficientSearchTerm} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.OpportunityDetails.NegateInefficientSearchTerm}
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCampaignId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCampaignName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdGroupName(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchTerm(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setEstimatedAov(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setExpectedRoas(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setExpectedConversionRate(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRevenueDiffScore(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRoasUnderperformingProb(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTargetRoas(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setClicks(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setConversions(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCost(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCostPerClick(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRevenue(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRoas(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTopImpressionPercentage(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCampaignEstimatedAov(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCampaignExpectedRoas(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCampaignExpectedConversionRate(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCampaignClicks(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCampaignCost(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCampaignCostPerClick(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.OpportunityDetails.NegateInefficientSearchTerm.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.OpportunityDetails.NegateInefficientSearchTerm} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCampaignId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCampaignName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAdGroupName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSearchTerm();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getEstimatedAov();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getExpectedRoas();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getExpectedConversionRate();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getRevenueDiffScore();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getRoasUnderperformingProb();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getTargetRoas();
  if (f !== 0.0) {
    writer.writeDouble(
      23,
      f
    );
  }
  f = message.getClicks();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getConversions();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = message.getCost();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getCostPerClick();
  if (f !== 0.0) {
    writer.writeDouble(
      12,
      f
    );
  }
  f = message.getRevenue();
  if (f !== 0.0) {
    writer.writeDouble(
      13,
      f
    );
  }
  f = message.getRoas();
  if (f !== 0.0) {
    writer.writeDouble(
      14,
      f
    );
  }
  f = message.getTopImpressionPercentage();
  if (f !== 0.0) {
    writer.writeDouble(
      22,
      f
    );
  }
  f = message.getCampaignEstimatedAov();
  if (f !== 0.0) {
    writer.writeDouble(
      17,
      f
    );
  }
  f = message.getCampaignExpectedRoas();
  if (f !== 0.0) {
    writer.writeDouble(
      15,
      f
    );
  }
  f = message.getCampaignExpectedConversionRate();
  if (f !== 0.0) {
    writer.writeDouble(
      16,
      f
    );
  }
  f = message.getCampaignClicks();
  if (f !== 0) {
    writer.writeInt64(
      18,
      f
    );
  }
  f = message.getCampaignCost();
  if (f !== 0.0) {
    writer.writeDouble(
      19,
      f
    );
  }
  f = message.getCampaignCostPerClick();
  if (f !== 0.0) {
    writer.writeDouble(
      21,
      f
    );
  }
};


/**
 * optional string campaign_id = 1;
 * @return {string}
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.getCampaignId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.NegateInefficientSearchTerm} returns this
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.setCampaignId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string campaign_name = 2;
 * @return {string}
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.getCampaignName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.NegateInefficientSearchTerm} returns this
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.setCampaignName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ad_group_name = 3;
 * @return {string}
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.getAdGroupName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.NegateInefficientSearchTerm} returns this
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.setAdGroupName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string search_term = 20;
 * @return {string}
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.getSearchTerm = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityDetails.NegateInefficientSearchTerm} returns this
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.setSearchTerm = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional double estimated_aov = 8;
 * @return {number}
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.getEstimatedAov = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.NegateInefficientSearchTerm} returns this
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.setEstimatedAov = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional double expected_roas = 5;
 * @return {number}
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.getExpectedRoas = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.NegateInefficientSearchTerm} returns this
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.setExpectedRoas = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double expected_conversion_rate = 7;
 * @return {number}
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.getExpectedConversionRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.NegateInefficientSearchTerm} returns this
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.setExpectedConversionRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double revenue_diff_score = 6;
 * @return {number}
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.getRevenueDiffScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.NegateInefficientSearchTerm} returns this
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.setRevenueDiffScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double roas_underperforming_prob = 4;
 * @return {number}
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.getRoasUnderperformingProb = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.NegateInefficientSearchTerm} returns this
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.setRoasUnderperformingProb = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double target_roas = 23;
 * @return {number}
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.getTargetRoas = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 23, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.NegateInefficientSearchTerm} returns this
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.setTargetRoas = function(value) {
  return jspb.Message.setProto3FloatField(this, 23, value);
};


/**
 * optional int64 clicks = 9;
 * @return {number}
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.getClicks = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.NegateInefficientSearchTerm} returns this
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.setClicks = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional double conversions = 11;
 * @return {number}
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.getConversions = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.NegateInefficientSearchTerm} returns this
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.setConversions = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional double cost = 10;
 * @return {number}
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.getCost = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.NegateInefficientSearchTerm} returns this
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.setCost = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional double cost_per_click = 12;
 * @return {number}
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.getCostPerClick = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.NegateInefficientSearchTerm} returns this
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.setCostPerClick = function(value) {
  return jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional double revenue = 13;
 * @return {number}
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.getRevenue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.NegateInefficientSearchTerm} returns this
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.setRevenue = function(value) {
  return jspb.Message.setProto3FloatField(this, 13, value);
};


/**
 * optional double roas = 14;
 * @return {number}
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.getRoas = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.NegateInefficientSearchTerm} returns this
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.setRoas = function(value) {
  return jspb.Message.setProto3FloatField(this, 14, value);
};


/**
 * optional double top_impression_percentage = 22;
 * @return {number}
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.getTopImpressionPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 22, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.NegateInefficientSearchTerm} returns this
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.setTopImpressionPercentage = function(value) {
  return jspb.Message.setProto3FloatField(this, 22, value);
};


/**
 * optional double campaign_estimated_aov = 17;
 * @return {number}
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.getCampaignEstimatedAov = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 17, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.NegateInefficientSearchTerm} returns this
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.setCampaignEstimatedAov = function(value) {
  return jspb.Message.setProto3FloatField(this, 17, value);
};


/**
 * optional double campaign_expected_roas = 15;
 * @return {number}
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.getCampaignExpectedRoas = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.NegateInefficientSearchTerm} returns this
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.setCampaignExpectedRoas = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * optional double campaign_expected_conversion_rate = 16;
 * @return {number}
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.getCampaignExpectedConversionRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 16, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.NegateInefficientSearchTerm} returns this
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.setCampaignExpectedConversionRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 16, value);
};


/**
 * optional int64 campaign_clicks = 18;
 * @return {number}
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.getCampaignClicks = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.NegateInefficientSearchTerm} returns this
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.setCampaignClicks = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional double campaign_cost = 19;
 * @return {number}
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.getCampaignCost = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 19, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.NegateInefficientSearchTerm} returns this
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.setCampaignCost = function(value) {
  return jspb.Message.setProto3FloatField(this, 19, value);
};


/**
 * optional double campaign_cost_per_click = 21;
 * @return {number}
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.getCampaignCostPerClick = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 21, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails.NegateInefficientSearchTerm} returns this
 */
proto.entity.OpportunityDetails.NegateInefficientSearchTerm.prototype.setCampaignCostPerClick = function(value) {
  return jspb.Message.setProto3FloatField(this, 21, value);
};


/**
 * optional IncreaseKeywordCPCBid increase_keyword_cpc_bid = 1;
 * @return {?proto.entity.OpportunityDetails.IncreaseKeywordCPCBid}
 */
proto.entity.OpportunityDetails.prototype.getIncreaseKeywordCpcBid = function() {
  return /** @type{?proto.entity.OpportunityDetails.IncreaseKeywordCPCBid} */ (
    jspb.Message.getWrapperField(this, proto.entity.OpportunityDetails.IncreaseKeywordCPCBid, 1));
};


/**
 * @param {?proto.entity.OpportunityDetails.IncreaseKeywordCPCBid|undefined} value
 * @return {!proto.entity.OpportunityDetails} returns this
*/
proto.entity.OpportunityDetails.prototype.setIncreaseKeywordCpcBid = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.entity.OpportunityDetails.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.OpportunityDetails} returns this
 */
proto.entity.OpportunityDetails.prototype.clearIncreaseKeywordCpcBid = function() {
  return this.setIncreaseKeywordCpcBid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.OpportunityDetails.prototype.hasIncreaseKeywordCpcBid = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional IncreaseProductGroupCPCBid increase_product_group_cpc_bid = 2;
 * @return {?proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid}
 */
proto.entity.OpportunityDetails.prototype.getIncreaseProductGroupCpcBid = function() {
  return /** @type{?proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid} */ (
    jspb.Message.getWrapperField(this, proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid, 2));
};


/**
 * @param {?proto.entity.OpportunityDetails.IncreaseProductGroupCPCBid|undefined} value
 * @return {!proto.entity.OpportunityDetails} returns this
*/
proto.entity.OpportunityDetails.prototype.setIncreaseProductGroupCpcBid = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.entity.OpportunityDetails.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.OpportunityDetails} returns this
 */
proto.entity.OpportunityDetails.prototype.clearIncreaseProductGroupCpcBid = function() {
  return this.setIncreaseProductGroupCpcBid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.OpportunityDetails.prototype.hasIncreaseProductGroupCpcBid = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional AddKeywordFromShoppingSearchTerm add_keyword_from_shopping_search_term = 3;
 * @return {?proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm}
 */
proto.entity.OpportunityDetails.prototype.getAddKeywordFromShoppingSearchTerm = function() {
  return /** @type{?proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm} */ (
    jspb.Message.getWrapperField(this, proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm, 3));
};


/**
 * @param {?proto.entity.OpportunityDetails.AddKeywordFromShoppingSearchTerm|undefined} value
 * @return {!proto.entity.OpportunityDetails} returns this
*/
proto.entity.OpportunityDetails.prototype.setAddKeywordFromShoppingSearchTerm = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.entity.OpportunityDetails.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.OpportunityDetails} returns this
 */
proto.entity.OpportunityDetails.prototype.clearAddKeywordFromShoppingSearchTerm = function() {
  return this.setAddKeywordFromShoppingSearchTerm(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.OpportunityDetails.prototype.hasAddKeywordFromShoppingSearchTerm = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional AddKeywordFromOrganicSearchTerm add_keyword_from_organic_search_term = 5;
 * @return {?proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm}
 */
proto.entity.OpportunityDetails.prototype.getAddKeywordFromOrganicSearchTerm = function() {
  return /** @type{?proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm} */ (
    jspb.Message.getWrapperField(this, proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm, 5));
};


/**
 * @param {?proto.entity.OpportunityDetails.AddKeywordFromOrganicSearchTerm|undefined} value
 * @return {!proto.entity.OpportunityDetails} returns this
*/
proto.entity.OpportunityDetails.prototype.setAddKeywordFromOrganicSearchTerm = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.entity.OpportunityDetails.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.OpportunityDetails} returns this
 */
proto.entity.OpportunityDetails.prototype.clearAddKeywordFromOrganicSearchTerm = function() {
  return this.setAddKeywordFromOrganicSearchTerm(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.OpportunityDetails.prototype.hasAddKeywordFromOrganicSearchTerm = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional AddDynamicSearchForSitemapFolder add_dynamic_search_for_sitemap_folder = 6;
 * @return {?proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder}
 */
proto.entity.OpportunityDetails.prototype.getAddDynamicSearchForSitemapFolder = function() {
  return /** @type{?proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder} */ (
    jspb.Message.getWrapperField(this, proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder, 6));
};


/**
 * @param {?proto.entity.OpportunityDetails.AddDynamicSearchForSitemapFolder|undefined} value
 * @return {!proto.entity.OpportunityDetails} returns this
*/
proto.entity.OpportunityDetails.prototype.setAddDynamicSearchForSitemapFolder = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.entity.OpportunityDetails.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.OpportunityDetails} returns this
 */
proto.entity.OpportunityDetails.prototype.clearAddDynamicSearchForSitemapFolder = function() {
  return this.setAddDynamicSearchForSitemapFolder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.OpportunityDetails.prototype.hasAddDynamicSearchForSitemapFolder = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional NegateInefficientSearchTerm negate_inefficient_search_term = 7;
 * @return {?proto.entity.OpportunityDetails.NegateInefficientSearchTerm}
 */
proto.entity.OpportunityDetails.prototype.getNegateInefficientSearchTerm = function() {
  return /** @type{?proto.entity.OpportunityDetails.NegateInefficientSearchTerm} */ (
    jspb.Message.getWrapperField(this, proto.entity.OpportunityDetails.NegateInefficientSearchTerm, 7));
};


/**
 * @param {?proto.entity.OpportunityDetails.NegateInefficientSearchTerm|undefined} value
 * @return {!proto.entity.OpportunityDetails} returns this
*/
proto.entity.OpportunityDetails.prototype.setNegateInefficientSearchTerm = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.entity.OpportunityDetails.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.OpportunityDetails} returns this
 */
proto.entity.OpportunityDetails.prototype.clearNegateInefficientSearchTerm = function() {
  return this.setNegateInefficientSearchTerm(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.OpportunityDetails.prototype.hasNegateInefficientSearchTerm = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional int32 priority_within_type = 4;
 * @return {number}
 */
proto.entity.OpportunityDetails.prototype.getPriorityWithinType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.entity.OpportunityDetails} returns this
 */
proto.entity.OpportunityDetails.prototype.setPriorityWithinType = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.OpportunityStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.OpportunityStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.OpportunityStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityStatus.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.OpportunityStatus}
 */
proto.entity.OpportunityStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.OpportunityStatus;
  return proto.entity.OpportunityStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.OpportunityStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.OpportunityStatus}
 */
proto.entity.OpportunityStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.OpportunityStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.OpportunityStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.OpportunityStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.entity.OpportunityStatus.Option = {
  UNDEFINED: 0,
  NEW: 1,
  OPEN: 2,
  CLOSED: 3,
  COMPLETED: 4,
  FAILED: 5,
  SKIPPED: 6
};


/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.OpportunityExecutionFailure.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.OpportunityExecutionFailure.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.OpportunityExecutionFailure.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.OpportunityExecutionFailure} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityExecutionFailure.toObject = function(includeInstance, msg) {
  var f, obj = {
    opportunityId: (f = msg.getOpportunityId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f),
    error: jspb.Message.getFieldWithDefault(msg, 2, ""),
    errorObjectsList: jspb.Message.toObjectList(msg.getErrorObjectsList(),
    proto_errorPb_error_pb.Error.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.OpportunityExecutionFailure}
 */
proto.entity.OpportunityExecutionFailure.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.OpportunityExecutionFailure;
  return proto.entity.OpportunityExecutionFailure.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.OpportunityExecutionFailure} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.OpportunityExecutionFailure}
 */
proto.entity.OpportunityExecutionFailure.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setOpportunityId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    case 3:
      var value = new proto_errorPb_error_pb.Error;
      reader.readMessage(value,proto_errorPb_error_pb.Error.deserializeBinaryFromReader);
      msg.addErrorObjects(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.OpportunityExecutionFailure.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.OpportunityExecutionFailure.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.OpportunityExecutionFailure} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityExecutionFailure.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOpportunityId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getErrorObjectsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto_errorPb_error_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional common.ObjectID opportunity_id = 1;
 * @return {?proto.common.ObjectID}
 */
proto.entity.OpportunityExecutionFailure.prototype.getOpportunityId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 1));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.OpportunityExecutionFailure} returns this
*/
proto.entity.OpportunityExecutionFailure.prototype.setOpportunityId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.OpportunityExecutionFailure} returns this
 */
proto.entity.OpportunityExecutionFailure.prototype.clearOpportunityId = function() {
  return this.setOpportunityId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.OpportunityExecutionFailure.prototype.hasOpportunityId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string error = 2;
 * @return {string}
 */
proto.entity.OpportunityExecutionFailure.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityExecutionFailure} returns this
 */
proto.entity.OpportunityExecutionFailure.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated errorPb.Error error_objects = 3;
 * @return {!Array<!proto.errorPb.Error>}
 */
proto.entity.OpportunityExecutionFailure.prototype.getErrorObjectsList = function() {
  return /** @type{!Array<!proto.errorPb.Error>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_errorPb_error_pb.Error, 3));
};


/**
 * @param {!Array<!proto.errorPb.Error>} value
 * @return {!proto.entity.OpportunityExecutionFailure} returns this
*/
proto.entity.OpportunityExecutionFailure.prototype.setErrorObjectsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.errorPb.Error=} opt_value
 * @param {number=} opt_index
 * @return {!proto.errorPb.Error}
 */
proto.entity.OpportunityExecutionFailure.prototype.addErrorObjects = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.errorPb.Error, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.OpportunityExecutionFailure} returns this
 */
proto.entity.OpportunityExecutionFailure.prototype.clearErrorObjectsList = function() {
  return this.setErrorObjectsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.NewOpportunitySuspension.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.NewOpportunitySuspension.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.NewOpportunitySuspension} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.NewOpportunitySuspension.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    userId: (f = msg.getUserId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f),
    expirationTime: (f = msg.getExpirationTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    details: (f = msg.getDetails()) && proto.entity.OpportunitySuspensionDetails.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.NewOpportunitySuspension}
 */
proto.entity.NewOpportunitySuspension.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.NewOpportunitySuspension;
  return proto.entity.NewOpportunitySuspension.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.NewOpportunitySuspension} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.NewOpportunitySuspension}
 */
proto.entity.NewOpportunitySuspension.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setUserId(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setExpirationTime(value);
      break;
    case 4:
      var value = new proto.entity.OpportunitySuspensionDetails;
      reader.readMessage(value,proto.entity.OpportunitySuspensionDetails.deserializeBinaryFromReader);
      msg.setDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.NewOpportunitySuspension.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.NewOpportunitySuspension.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.NewOpportunitySuspension} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.NewOpportunitySuspension.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getUserId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getExpirationTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDetails();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.entity.OpportunitySuspensionDetails.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.NewOpportunitySuspension.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.NewOpportunitySuspension} returns this
*/
proto.entity.NewOpportunitySuspension.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.NewOpportunitySuspension} returns this
 */
proto.entity.NewOpportunitySuspension.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.NewOpportunitySuspension.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.ObjectID user_id = 2;
 * @return {?proto.common.ObjectID}
 */
proto.entity.NewOpportunitySuspension.prototype.getUserId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 2));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.NewOpportunitySuspension} returns this
*/
proto.entity.NewOpportunitySuspension.prototype.setUserId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.NewOpportunitySuspension} returns this
 */
proto.entity.NewOpportunitySuspension.prototype.clearUserId = function() {
  return this.setUserId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.NewOpportunitySuspension.prototype.hasUserId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp expiration_time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.entity.NewOpportunitySuspension.prototype.getExpirationTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.entity.NewOpportunitySuspension} returns this
*/
proto.entity.NewOpportunitySuspension.prototype.setExpirationTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.NewOpportunitySuspension} returns this
 */
proto.entity.NewOpportunitySuspension.prototype.clearExpirationTime = function() {
  return this.setExpirationTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.NewOpportunitySuspension.prototype.hasExpirationTime = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional OpportunitySuspensionDetails details = 4;
 * @return {?proto.entity.OpportunitySuspensionDetails}
 */
proto.entity.NewOpportunitySuspension.prototype.getDetails = function() {
  return /** @type{?proto.entity.OpportunitySuspensionDetails} */ (
    jspb.Message.getWrapperField(this, proto.entity.OpportunitySuspensionDetails, 4));
};


/**
 * @param {?proto.entity.OpportunitySuspensionDetails|undefined} value
 * @return {!proto.entity.NewOpportunitySuspension} returns this
*/
proto.entity.NewOpportunitySuspension.prototype.setDetails = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.NewOpportunitySuspension} returns this
 */
proto.entity.NewOpportunitySuspension.prototype.clearDetails = function() {
  return this.setDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.NewOpportunitySuspension.prototype.hasDetails = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.OpportunitySuspension.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.OpportunitySuspension.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.OpportunitySuspension} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunitySuspension.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: (f = msg.getSiteId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f),
    suspensionId: (f = msg.getSuspensionId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f),
    userId: (f = msg.getUserId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f),
    details: (f = msg.getDetails()) && proto.entity.OpportunitySuspensionDetails.toObject(includeInstance, f),
    expirationTime: (f = msg.getExpirationTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    crudFields: (f = msg.getCrudFields()) && proto_common_crudFields_pb.CRUDFields.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.OpportunitySuspension}
 */
proto.entity.OpportunitySuspension.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.OpportunitySuspension;
  return proto.entity.OpportunitySuspension.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.OpportunitySuspension} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.OpportunitySuspension}
 */
proto.entity.OpportunitySuspension.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setSiteId(value);
      break;
    case 2:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setSuspensionId(value);
      break;
    case 3:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setUserId(value);
      break;
    case 4:
      var value = new proto.entity.OpportunitySuspensionDetails;
      reader.readMessage(value,proto.entity.OpportunitySuspensionDetails.deserializeBinaryFromReader);
      msg.setDetails(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setExpirationTime(value);
      break;
    case 6:
      var value = new proto_common_crudFields_pb.CRUDFields;
      reader.readMessage(value,proto_common_crudFields_pb.CRUDFields.deserializeBinaryFromReader);
      msg.setCrudFields(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.OpportunitySuspension.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.OpportunitySuspension.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.OpportunitySuspension} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunitySuspension.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getSuspensionId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getUserId();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getDetails();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.entity.OpportunitySuspensionDetails.serializeBinaryToWriter
    );
  }
  f = message.getExpirationTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCrudFields();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto_common_crudFields_pb.CRUDFields.serializeBinaryToWriter
    );
  }
};


/**
 * optional common.ObjectID site_id = 1;
 * @return {?proto.common.ObjectID}
 */
proto.entity.OpportunitySuspension.prototype.getSiteId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 1));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.OpportunitySuspension} returns this
*/
proto.entity.OpportunitySuspension.prototype.setSiteId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.OpportunitySuspension} returns this
 */
proto.entity.OpportunitySuspension.prototype.clearSiteId = function() {
  return this.setSiteId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.OpportunitySuspension.prototype.hasSiteId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.ObjectID suspension_id = 2;
 * @return {?proto.common.ObjectID}
 */
proto.entity.OpportunitySuspension.prototype.getSuspensionId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 2));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.OpportunitySuspension} returns this
*/
proto.entity.OpportunitySuspension.prototype.setSuspensionId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.OpportunitySuspension} returns this
 */
proto.entity.OpportunitySuspension.prototype.clearSuspensionId = function() {
  return this.setSuspensionId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.OpportunitySuspension.prototype.hasSuspensionId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional common.ObjectID user_id = 3;
 * @return {?proto.common.ObjectID}
 */
proto.entity.OpportunitySuspension.prototype.getUserId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 3));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.OpportunitySuspension} returns this
*/
proto.entity.OpportunitySuspension.prototype.setUserId = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.OpportunitySuspension} returns this
 */
proto.entity.OpportunitySuspension.prototype.clearUserId = function() {
  return this.setUserId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.OpportunitySuspension.prototype.hasUserId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional OpportunitySuspensionDetails details = 4;
 * @return {?proto.entity.OpportunitySuspensionDetails}
 */
proto.entity.OpportunitySuspension.prototype.getDetails = function() {
  return /** @type{?proto.entity.OpportunitySuspensionDetails} */ (
    jspb.Message.getWrapperField(this, proto.entity.OpportunitySuspensionDetails, 4));
};


/**
 * @param {?proto.entity.OpportunitySuspensionDetails|undefined} value
 * @return {!proto.entity.OpportunitySuspension} returns this
*/
proto.entity.OpportunitySuspension.prototype.setDetails = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.OpportunitySuspension} returns this
 */
proto.entity.OpportunitySuspension.prototype.clearDetails = function() {
  return this.setDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.OpportunitySuspension.prototype.hasDetails = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp expiration_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.entity.OpportunitySuspension.prototype.getExpirationTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.entity.OpportunitySuspension} returns this
*/
proto.entity.OpportunitySuspension.prototype.setExpirationTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.OpportunitySuspension} returns this
 */
proto.entity.OpportunitySuspension.prototype.clearExpirationTime = function() {
  return this.setExpirationTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.OpportunitySuspension.prototype.hasExpirationTime = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional common.CRUDFields crud_fields = 6;
 * @return {?proto.common.CRUDFields}
 */
proto.entity.OpportunitySuspension.prototype.getCrudFields = function() {
  return /** @type{?proto.common.CRUDFields} */ (
    jspb.Message.getWrapperField(this, proto_common_crudFields_pb.CRUDFields, 6));
};


/**
 * @param {?proto.common.CRUDFields|undefined} value
 * @return {!proto.entity.OpportunitySuspension} returns this
*/
proto.entity.OpportunitySuspension.prototype.setCrudFields = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.OpportunitySuspension} returns this
 */
proto.entity.OpportunitySuspension.prototype.clearCrudFields = function() {
  return this.setCrudFields(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.OpportunitySuspension.prototype.hasCrudFields = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.OpportunitySuspensionDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.OpportunitySuspensionDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.OpportunitySuspensionDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunitySuspensionDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    targetsMap: (f = msg.getTargetsMap()) ? f.toObject(includeInstance, undefined) : [],
    reasonType: jspb.Message.getFieldWithDefault(msg, 2, ""),
    reasonComment: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.OpportunitySuspensionDetails}
 */
proto.entity.OpportunitySuspensionDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.OpportunitySuspensionDetails;
  return proto.entity.OpportunitySuspensionDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.OpportunitySuspensionDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.OpportunitySuspensionDetails}
 */
proto.entity.OpportunitySuspensionDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getTargetsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReasonType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setReasonComment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.OpportunitySuspensionDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.OpportunitySuspensionDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.OpportunitySuspensionDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunitySuspensionDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTargetsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getReasonType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getReasonComment();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * map<string, string> targets = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.entity.OpportunitySuspensionDetails.prototype.getTargetsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.entity.OpportunitySuspensionDetails} returns this
 */
proto.entity.OpportunitySuspensionDetails.prototype.clearTargetsMap = function() {
  this.getTargetsMap().clear();
  return this;};


/**
 * optional string reason_type = 2;
 * @return {string}
 */
proto.entity.OpportunitySuspensionDetails.prototype.getReasonType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunitySuspensionDetails} returns this
 */
proto.entity.OpportunitySuspensionDetails.prototype.setReasonType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string reason_comment = 3;
 * @return {string}
 */
proto.entity.OpportunitySuspensionDetails.prototype.getReasonComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunitySuspensionDetails} returns this
 */
proto.entity.OpportunitySuspensionDetails.prototype.setReasonComment = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.SuspendedOpportunity.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.SuspendedOpportunity.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.SuspendedOpportunity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.SuspendedOpportunity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.SuspendedOpportunity.toObject = function(includeInstance, msg) {
  var f, obj = {
    opportunity: (f = msg.getOpportunity()) && proto.entity.Opportunity.toObject(includeInstance, f),
    suspensionsList: jspb.Message.toObjectList(msg.getSuspensionsList(),
    proto.entity.OpportunitySuspension.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.SuspendedOpportunity}
 */
proto.entity.SuspendedOpportunity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.SuspendedOpportunity;
  return proto.entity.SuspendedOpportunity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.SuspendedOpportunity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.SuspendedOpportunity}
 */
proto.entity.SuspendedOpportunity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.entity.Opportunity;
      reader.readMessage(value,proto.entity.Opportunity.deserializeBinaryFromReader);
      msg.setOpportunity(value);
      break;
    case 2:
      var value = new proto.entity.OpportunitySuspension;
      reader.readMessage(value,proto.entity.OpportunitySuspension.deserializeBinaryFromReader);
      msg.addSuspensions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.SuspendedOpportunity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.SuspendedOpportunity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.SuspendedOpportunity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.SuspendedOpportunity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOpportunity();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.entity.Opportunity.serializeBinaryToWriter
    );
  }
  f = message.getSuspensionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.entity.OpportunitySuspension.serializeBinaryToWriter
    );
  }
};


/**
 * optional Opportunity opportunity = 1;
 * @return {?proto.entity.Opportunity}
 */
proto.entity.SuspendedOpportunity.prototype.getOpportunity = function() {
  return /** @type{?proto.entity.Opportunity} */ (
    jspb.Message.getWrapperField(this, proto.entity.Opportunity, 1));
};


/**
 * @param {?proto.entity.Opportunity|undefined} value
 * @return {!proto.entity.SuspendedOpportunity} returns this
*/
proto.entity.SuspendedOpportunity.prototype.setOpportunity = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.SuspendedOpportunity} returns this
 */
proto.entity.SuspendedOpportunity.prototype.clearOpportunity = function() {
  return this.setOpportunity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.SuspendedOpportunity.prototype.hasOpportunity = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated OpportunitySuspension suspensions = 2;
 * @return {!Array<!proto.entity.OpportunitySuspension>}
 */
proto.entity.SuspendedOpportunity.prototype.getSuspensionsList = function() {
  return /** @type{!Array<!proto.entity.OpportunitySuspension>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.entity.OpportunitySuspension, 2));
};


/**
 * @param {!Array<!proto.entity.OpportunitySuspension>} value
 * @return {!proto.entity.SuspendedOpportunity} returns this
*/
proto.entity.SuspendedOpportunity.prototype.setSuspensionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.entity.OpportunitySuspension=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.OpportunitySuspension}
 */
proto.entity.SuspendedOpportunity.prototype.addSuspensions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.entity.OpportunitySuspension, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.SuspendedOpportunity} returns this
 */
proto.entity.SuspendedOpportunity.prototype.clearSuspensionsList = function() {
  return this.setSuspensionsList([]);
};


goog.object.extend(exports, proto.entity);
